module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_vm._v("“They want you dead, or in their lie. "), _c('br'), _vm._v("There’s only one thing a man can do. "), _c('br'), _vm._v("Find something that’s his, "), _c('br'), _vm._v("and make an island for himself.” "), _c('br'), _vm._v("—Sergeant Welsh in Terrence Malick’s film "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Red Line")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6477a430","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/thepenaltyarea_00000.vue
// module id = 66
// module chunks = 0